module.exports = __webpack_public_path__ + "img/flow-desc3.a13b6ebb.png";